<script>
/* global L : true*/
import { openweathermap_api_key } from './../../js/api_keys'
import { httpGET } from './../../js/utils'
import { APIPOI } from './../../js/api_poi'
import { app_log } from './../../js/app_log'


import '../../../node_modules/leaflet.markercluster'

export default {
    name: "CityWeatherMixin",

    props: {
        weatherLayerToDisplay: Number,
    },

    watch: {
        weatherLayerToDisplay: function (newVal) {
            this.timeStampToDisplay = newVal;
            this.updateIcons();
        }
    },

    data() {
        return {
            city_weather_overlay: null,
            city_retrieved: [],
            city_weather_retrieved: [],
            latest_weather_timestamp: "",
            city_markers: [],
            raw_city_markers: [],
            weather_city_file: "",
            needFillingTimestamps: true,
            timeStamps: [],
            timeStampToDisplay: 0,
            popupOptions: [],
            loading_cities: false,
            current_position:[],
            previous_position:[],
        }
    },

    mounted() {
        this.city_markers = L.markerClusterGroup({
            zoomToBoundsOnClick: false,
            showCoverageOnHover: false,
        });

        this.overlay_maps["Weather"] = this.city_markers;

        this.popupOptions = {closeButton:true,
                                    autoClose: false,
                                    closeOnClick: false,
                                    autoPan: false,
                                    className: "popup-custom"};

        this.current_position =  L.latLng(0,0);
        this.previous_position = L.latLng(0,0);
    },

    methods: {

        onCitiyWeatherLayerAdded () {
            this.mymap.locate();
        },

        onLocateEnded() {
            if (this.previous_position.equals(L.latLng(0,0)) || this.current_position.distanceTo(this.previous_position) > 50000) {
                this.loading_cities = true;
                let prom =  APIPOI.getCities(this.current_position);
                prom.then((data) => {
                if (data.length > 0) {
                    let vm = this;
                    //on construit les markers

                    for (let i = 0 ; i < data.length ; i++) {
                        vm.city_markers.addLayer(L.marker(new L.LatLng(data[i].pos[0], data[i].pos[1])));
                    }
                    this.city_markers.on('animationend', this.onAnimationEnd);
                    this.onAnimationEnd();
                } else {
                    app_log.error("Could not find cities around you :(");
                }
                })
                .catch((err) => {
                app_log.error(err);
                })
                .finally(() => {
                    let vm = this;
                    vm.loading_cities = false;
                    vm.previous_position = vm.current_position;
                });
            }
        },

        onAnimationEnd () {
            var vm = this;

            this.city_markers._featureGroup.eachLayer(function (layer) {
                var _latlng = layer.getLatLng();
                var needFetching = true;
                for (let i = 0 ; i < vm.city_retrieved.length ; i++) {
                    if (vm.city_retrieved[i].latlng == _latlng) {
                        needFetching = false;
                        layer.openPopup();
                    }
                }
                if (vm.mymap.getBounds().contains(_latlng) && needFetching) {
                    httpGET("https://api.openweathermap.org/data/2.5/forecast?lat="
                            + _latlng.lat
                            + "&lon="
                            + _latlng.lng
                            + "&units=metric"
                            + "&APPID=" + openweathermap_api_key)
                    .then(response => {
                        var res = JSON.parse(response);
                        vm.city_retrieved.push({latlng:_latlng, weather: res});
                        let weather_icon = L.icon({
                            iconUrl: "https://openweathermap.org/img/wn/" + res.list[0].weather[0].icon + ".png",
                            iconSize:     [50, 50],});
                        layer.setIcon(weather_icon);
                        layer.closePopup();
                        layer.bindPopup("<h3>" + Math.round(res.list[0].main.temp) + " °C</h3>", vm.popupOptions).openPopup();

                        if (vm.needFillingTimestamps) {
                            for (let i = 0 ; i < res.list.length ; i++) {
                                vm.timeStamps.push(res.list[i].dt_txt);
                            }
                            vm.needFillingTimestamps = false;
                            vm.$emit('newWeatherTimestamps', vm.timeStamps);
                        }
                    });
                }
            });
        },

        updateIcons () {
            var vm = this;

            this.city_markers._featureGroup.eachLayer(function (layer) {
                var _latlng = layer.getLatLng();

                for (let i = 0 ; i < vm.city_retrieved.length ; i++) {
                    if (vm.city_retrieved[i].latlng == _latlng && vm.mymap.getBounds().contains(_latlng)) {
                        var res = vm.city_retrieved[i].weather;
                        
                        let weather_icon = L.icon({
                            iconUrl: "https://openweathermap.org/img/wn/" + res.list[vm.timeStampToDisplay].weather[0].icon + ".png",
                            iconSize:     [50, 50],});
                        layer.setIcon(weather_icon);
                        layer.closePopup();
                        layer.bindPopup("<h3>" + Math.round(res.list[vm.timeStampToDisplay].main.temp) + " °C</h3>", vm.popupOptions).openPopup();
                    }
                }
            });
        },

    },
}
</script>

<style>
    .popup-custom .leaflet-popup-content-wrapper {
        background-color: rgba(255, 255, 255, 0.6);
        text-align: center;
        border-radius: 0;
        padding:0px;
        box-shadow: 0 0 0 0;
    }

    .popup-custom .leaflet-popup-content-wrapper .leaflet-popup-content {
        margin: 0px 19px
    }

    .popup-custom .leaflet-popup-tip-container {
        width:0px;
        height: 0px;
    }
</style>
